import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs/index';
import { filter, map } from 'rxjs/operators';
import { AuthenticationActions } from './state/authentication.actions';
import { AuthState } from './state/authentication.reducer';
import { AuthenticationSelectors } from './state/authentication.selectors';

@Component({
    selector: 'login-component',
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit, OnDestroy {
    loginForm: FormGroup;
    authenticate$: Observable<AuthState>;
    subscription: Subscription = new Subscription();
    returnUrl: string;
    isInIframe: boolean;

    constructor(private formBuilder: FormBuilder,
                private route: ActivatedRoute,
                private router: Router,
                private store: Store<any>,
                private authenticationSelectors: AuthenticationSelectors) {
        const navigation = this.router.getCurrentNavigation();
        this.returnUrl = navigation.extras.state ? navigation.extras.state.returnUrl : undefined;
        this.authenticate$ = this.authenticationSelectors.selectAuthenticate();
    }

    ngOnInit(): void {
        this.isInIframe = window.self !== window.top;

        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
            rememberMe: []
        });

        let username;
        const password = localStorage.getItem('password');
        const rememberMe = JSON.parse(localStorage.getItem('rememberMe')) || false;

        const subscription = this.authenticate$
            .subscribe(authenticated => {
                    username = !rememberMe ? authenticated.username : localStorage.getItem('username');
                    if (this.isInIframe) {
                     window.parent.postMessage({ reAuthenticatedLegacyUser: !authenticated.isUserAuthenticated }, '*'); // change it to exact url
                    }

            });
        this.subscription.add(subscription);

        this.loginForm.get('rememberMe')
            .setValue(rememberMe);
        this.loginForm.get('username')
            .setValue(username);
        if (rememberMe) {
            this.loginForm.get('password')
                .setValue(password);
        }
    }

    // convenience getter for easy access to form fields
    get formControl(): { [p: string]: AbstractControl } { return this.loginForm.controls; }

    login(): void {
        // console.log('Validating Form..... ');
        if (this.loginForm.invalid) {
            return;
        }

       //  console.log('Authenticating User..... ');

        this.store.dispatch(AuthenticationActions
            .loginUser({
                username: this.formControl.username.value,
                password: this.formControl.password.value,
                rememberMe: this.formControl.rememberMe.value,
                returnUrl: this.returnUrl,
                isAuthenticatedFromAdmin: false,
                returnUrlPathParams: {...this.route.snapshot.queryParams},
                accountAccessToken: undefined}));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
